<template>
  <div
    ref="panel"
    :class="classes"
  >
    <div class="share">
      <div class="title-close">
        <h2>Share</h2>

        <button @click="hideSubscribe">Close</button>
      </div>

      <div class="share-url-tools">
        <div :class="['share-url', {copied: urlCopied, 'double': mp3Url}]">
          <input
            :value="episodeUrl"
            type="text"
            readonly
          >
          <button
            v-clipboard:copy="episodeUrl"
            v-clipboard:success="() => { urlCopied = true }"
            aria-label="Copy Episode URL Button"
            @click="store.sendShareSubscribeEvent('share', 'COPY', 'url')"
          ><span><span>Share&nbsp;</span>Url</span> <icon-copy /></button>
        </div>

        <a
          :href="`${store.state.episode.episode_url}?share=true`"
          :class="{'share-tools': true, 'double': mp3Url}"
          target="simplecast-share"
          title="Sharing Tools"
          @click="store.sendShareSubscribeEvent('share', ' CLICK', 'share')"
        >Sharing<span>&nbsp;Tools</span> <icon-open /></a>

        <a
          v-if="mp3Url"
          :href="mp3Url"
          class="share-mp3 double"
          target="blank"
          title="Download MP3"
          @click="store.sendShareSubscribeEvent('share', 'DOWNLOAD', 'mp3')"
        ><span>Download&nbsp;</span>MP3 <icon-download /></a>
      </div>
    </div>

    <div class="subscribe">
      <div>
        <div class="title-close">
          <h2>Subscribe</h2>
        </div>

        <div class="social-more">
          <ul>
            <li v-if="getChannelUrl('Apple Podcasts')">
              <a
                :href="getChannelUrl('Apple Podcasts')"
                title="Apple Podcasts"
                target="simplecast"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Apple Podcasts')">
                <icon-apple-podcasts />
              </a>
            </li>
            <li v-if="getChannelUrl('Spotify')">
              <a
                :href="getChannelUrl('Spotify')"
                title="Spotify"
                target="simplecast"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Spotify')">
                <spotify />
              </a>
            </li>
            <li v-if="getChannelUrl('Google Podcasts')">
              <a
                :href="getChannelUrl('Google Podcasts')"
                target="simplecast"
                title="Google Podcasts"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Google Podcasts')">
                <google-podcasts />
              </a>
            </li>
            <li v-if="getChannelUrl('Breaker')">
              <a
                :href="getChannelUrl('Breaker')"
                target="simplecast"
                title="Breaker"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Breaker')">
                <breaker />
              </a>
            </li>
            <li v-if="getChannelUrl('iHeartRadio')">
              <a
                :href="getChannelUrl('iHeartRadio')"
                target="simplecast"
                title="iHeartRadio"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'iHeartRadio')">
                <iheart />
              </a>
            </li>
            <li v-if="getChannelUrl('Overcast')">
              <a
                :href="getChannelUrl('Overcast')"
                target="simplecast"
                title="Overcast"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Overcast')">
                <overcast />
              </a>
            </li>
            <li v-if="getChannelUrl('Pocketcast')">
              <a
                :href="getChannelUrl('Pocketcast')"
                target="simplecast"
                title="Pocket Casts"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Pocketcast')">
                <pocket-casts />
              </a>
            </li>
            <li v-if="getChannelUrl('RadioPublic')">
              <a
                :href="getChannelUrl('RadioPublic')"
                target="simplecast"
                title="RadioPublic"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'RadioPublic')">
                <radio-public />
              </a>
            </li>
            <li v-if="getChannelUrl('Stitcher')">
              <a
                :href="getChannelUrl('Stitcher')"
                target="simplecast"
                title="Stitcher"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Stitcher')">
                <stitcher />
              </a>
            </li>
            <li v-if="getChannelUrl('Tune In')">
              <a
                :href="getChannelUrl('Tune In')"
                target="simplecast"
                title="Tune In"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Tune In')">
                <tune-in />
              </a>
            </li>
            <li v-if="rssUrl">
              <a
                :href="rssUrl"
                target="simplecast"
                title="RSS Link"
                @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'RSS Link')"
              ><IconRss /></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="powered-by">
        Powered by
        <a
          href="https://simplecast.com"
          target="_blank">Simplecast</a>
      </div>
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import Breaker from '../assets/svg/breaker.svg'
import GooglePodcasts from '../assets/svg/google-podcasts.svg'
import IconApplePodcasts from '../assets/svg/apple-podcasts.svg'
import IconCopy from '../assets/svg/copy.svg'
import IconDownload from '../assets/svg/download.svg'
import IconOpen from '../assets/svg/open.svg'
import IconRss from '../assets/svg/rss.svg'
import Iheart from '../assets/svg/iheart.svg'
import MetaInfo from './MetaInfo'
import Overcast from '../assets/svg/overcast.svg'
import PocketCasts from '../assets/svg/pocket-casts.svg'
import RadioPublic from '../assets/svg/radiopublic.svg'
import Spotify from '../assets/svg/spotify.svg'
import Stitcher from '../assets/svg/stitcher.svg'
import Store from '../store'
import TuneIn from '../assets/svg/tune-in.svg'

export default {
  components: {
    Artwork,
    Breaker,
    GooglePodcasts,
    IconApplePodcasts,
    IconCopy,
    IconDownload,
    IconOpen,
    IconRss,
    Iheart,
    MetaInfo,
    Overcast,
    PocketCasts,
    RadioPublic,
    Spotify,
    Stitcher,
    TuneIn
  },
  data () {
    return {
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0,
      store: Store,
      urlCopied: false
    }
  },
  computed: {
    mp3Url () {
      if (!this.store.state.podcast.allow_mp3_downloads) return false
      return this.store.state.episode.enclosure_url
    },
    classes () {
      const panelClasses = ['subscribe-panel', this.size]

      if (this.isDark) panelClasses.push('dark')
      if (this.offsetWidth < 550) panelClasses.push('panel-small')
      if (this.offsetWidth < 320) panelClasses.push('panel-smallest')
      if (this.offsetWidth < 270) panelClasses.push('hide-icons')
      if (this.offsetHeight < 190) panelClasses.push('panel-thin')
      if (this.offsetHeight < 125) panelClasses.push('panel-tiny')

      return panelClasses
    },
    episodeUrl () {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== '' ? this.store.state.episode.custom_url : this.store.state.episode.episode_url
    },
    isDark () { return this.store.state.isDark },
    itunesUrl () {
      if (this.store.state.podcast.itunes_url && this.store.state.podcast.itunes_url !== '') {
        return this.store.state.podcast.itunes_url
      }

      return false
    },
    rssUrl () {
      if (this.store.state.podcast.external_feed_url && this.store.state.podcast.external_feed_url !== '') {
        return this.store.state.podcast.external_feed_url
      }
      if (this.store.state.podcast.feed_url && this.store.state.podcast.feed_url !== '') {
        return this.store.state.podcast.feed_url
      }

      return false
    },
    size () { return this.store.state.size }
  },
  watch: {
    urlCopied (val) {
      if (val) setTimeout(() => { this.urlCopied = false }, 2000)
    }
  },
  created () {
    window.addEventListener('resize', this.setOffsets)
  },
  mounted () {
    this.setOffsets()
  },
  methods: {
    getChannelUrl (name) {
      let c = this.store.state.distributionChannels && this.store.state.distributionChannels.find(channel => {
        if (channel.distribution_channel) return channel.distribution_channel.name === name

        return channel.name === name
      })
      return c && c.url
    },
    hideSubscribe () {
      this.store.setShowSubscribe(false)
    },
    setOffsets () {
      const style = window.getComputedStyle(this.$refs.panel, null)
      const height = parseInt(style.getPropertyValue('height'))
      const padding = parseInt(style.getPropertyValue('padding') || 0)
      const border = parseInt(style.getPropertyValue('border-width'))

      this.innerHeight = height - (padding * 2) - (border * 2)
      this.offsetWidth = this.$refs.panel.offsetWidth + padding
      this.offsetHeight = this.$refs.panel.offsetHeight
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.subscribe-panel {
  .meta-info {
    h1 {
      @include font-s-embed(700);
    }
    h2 {
     @include font-xxs();
    }
  }
}
</style>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.subscribe {
  align-items: flex-end;
  display: flex;
  margin-top: 12px;
  justify-content: space-between;
}

.powered-by {
  @include font-xs();
  a {
    color: $black-800;
  }
  .dark & {
    color: $white-000;
    a {
      color: $white-000;
    }
  }
}

.subscribe-panel {
  background: none;
  border: solid 1px $black-trans-200;
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  padding: 15px 20px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;

  &.dark {
    border-color: $white-trans-300;

    div.title-close {
      button,
      h2 {
        color: $white-trans-800;
        text-shadow: 0 0 2px $black-800;
      }
    }
    .share {
      .share-url-tools {
        .share-url.copied {
          input,
          button {
            &,
            &:active,
            &:hover {
              background: $green-100;
              color: $black-trans-800;
            }
            svg {
              fill: $black-trans-800;
            }
          }
        }
        .share-url button,
        .share-tools,
        .share-mp3 {
          border-color: $white-trans-400;
          color: $white-trans-800;
          background: $black-800;

          &:hover {
            background: $grey-700;
            opacity: .9;
          }
          &:active {
            background: $white-trans-200;
          }

          svg {
            fill: $white-trans-800;
          }
        }
      }
    }
  }

  div.title-close {
    display: flex;
    margin-bottom: 18px;

    h2 {
      flex: 1;
      margin: 0;
      text-shadow: 0 0 2px $white-000;
      @include font-m-embed(700);
    }
    button {
      background: transparent;
      border: none;
      cursor: pointer;
      margin: 0;
      padding: 0;
      text-decoration: underline;
      text-transform: uppercase;
      @include font-m-mono(700);
    }
    h2,
    button {
      line-height: 14px;
    }
  }

  .share {
    flex-grow: 1;

    .share-url-tools {
      display: flex;

      button,
      .share-tools,
      .share-mp3 {
        align-items: center;
        background: none;
        border-radius: 2px;
        border: solid 1px $black-trans-400;
        cursor: pointer;
        display: flex;
        justify-content: center;
        margin: 0;
        text-transform: uppercase;
        transition: background .2s ease-in-out;
        @include font-s();
        background: $white-000;
        &:hover {
          background: $grey-100;
          opacity: .9;
        }
        padding: 0 8px;
      }

      .share-url {
        display: flex;
        margin-right: 40px;
        width: 70%;

        input,
        button {
          transition: background .2s ease-in-out;
        }

        &.copied {
          input,
          button {
            background: $green-100;
          }
        }
        input {
          background: $grey-100;
          border: solid 1px $black-trans-400;
          border-radius: 2px;
          flex-grow: 1;
          margin: 0 8px 0 0;
          padding: 0 8px;

          @include font-s();
        }
        button {
          height: 36px;
          width: 36px;
          span {
            display: none;
          }
        }
      }
      .share-tools,
      .share-mp3 {
        color: $black-trans-800;
        text-decoration: none;
        width: 30%;
        svg {
          margin-left: 8px;
          vertical-align: middle;
        }
      }

      .share-mp3 {
        margin-left: 8px;

        svg {
          height: 12px;
        }
      }
    }
  }

  &.panel-small {
    .powered-by {
      display: none;
    }
    .share {
      .share-tools {
        width: 50%;
      }
      .share-url {
        margin-right: 8px;
        width: 50%;

        &.double {
          width: 25%;

          button {
            span {
              display: inline-block;

              > span {
                display: none;
              }
            }
          }
        }

        input {
          display: none;
        }
        button {
          width: 100%;

          span {
            display: inline-block;

            > span {
              // display: none;
            }
          }
          > span {
            margin-right: 8px;
          }
        }
      }
      .share-mp3 {
        width: 25%;

        span {
          display: none;
        }
      }
    }
  }
  &.panel-smallest {
    .share {
      .share-url,
      .share-tools,
      .share-mp3 {
        &.double {
          width: 33%;
        }
      }
      .share-url button span span {
        display: none;
      }
      .share-tools span {
        display: none;
      }
    }
    &.hide-icons {
      .share {
        svg {
          display: none;
        }
        .share-url button > span {
          margin-right: 0;
        }
      }
    }
  }
  &.panel-thin {
    .title-close {
      margin-bottom: 8px;
    }
    .share {
      .share-url {
        button {
          height: 30px;
        }
      }
    }
  }
  &.panel-tiny {
    padding: 4px;

    .title-close {
      margin-bottom: 5px;

      h2 {
        font-size: 12px;
      }
    }
    .social-more {
      ul li {
        margin-right: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
      svg {
        height: 18px;
        width: 18px;
      }
    }
    .share {
      .share-url button,
      .share-tools {
        font-size: 11px;
      }
      .share-url {
        button {
          height: 25px;
        }
      }
    }
    .subscribe {
      margin-top: 6px;
    }
  }
}
.social-more {
  align-items: flex-start;
  display: flex;
  flex: 1;
  ul {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin-right: 20px;
      margin-bottom: 4px;
      &:last-child {
        margin-right: 0;
      }
      a {
        color: $black-800;
        display: inline-block;
        line-height: 0;
        text-transform: uppercase;

        @include font-s(700);
      }
    }
  }
  svg {
    height: 24px;
    width: 24px;
    vertical-align: bottom;
  }
}
</style>
